<div class="search-container">
  <div class="filters">
    <input
      type="text"
      [(ngModel)]="searchTerm"
      placeholder="Search Items"
      (keypress)="onKeypressEvent($event)"
    />
    <div
      class="date-filter"
      (click)="showDatepicker()"
      outsideClick
      (outsideClick)="onDatepickerClickedOutside()"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
      >
        <path
          d="M7.5 10.0396H5.83333V11.7062H7.5V10.0396ZM10.8333 10.0396H9.16667V11.7062H10.8333V10.0396ZM14.1667 10.0396H12.5V11.7062H14.1667V10.0396ZM15.8333 4.20622H15V2.53955H13.3333V4.20622H6.66667V2.53955H5V4.20622H4.16667C3.24167 4.20622 2.50833 4.95622 2.50833 5.87288L2.5 17.5396C2.5 18.4562 3.24167 19.2062 4.16667 19.2062H15.8333C16.75 19.2062 17.5 18.4562 17.5 17.5396V5.87288C17.5 4.95622 16.75 4.20622 15.8333 4.20622ZM15.8333 17.5396H4.16667V8.37288H15.8333V17.5396Z"
          fill="#2DBBFC"
        />
      </svg>
      <span>{{ filteringDateString }}</span>
      <icn-calendar-datepicker
        (apply)="onDatepickerApply($event)"
        (cancel)="hideDatepicker()"
      >
      </icn-calendar-datepicker>
    </div>
  </div>
  <div class="buttons">
    <button title="Search" class="search" (click)="doSearch()">search</button>
  </div>
</div>
<div class="grid-container">
  <evrideo-ag-grid-evrideo-header [selectedCount]="selectedTableItemsCount">
    <div
      [class.button-disabled]="!selectedTableItemsCount"
      class="ai-button"
      title="Schedule AI Job"
      (click)="onAIButtonClicked()"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
      >
        <g clip-path="url(#clip0_6443_187)">
          <path
            d="M17.5092 4.88062H6.49107C5.39572 4.88062 4.50781 5.76852 4.50781 6.86388V17.882C4.50781 18.9774 5.39572 19.8653 6.49107 19.8653H17.5092C18.6046 19.8653 19.4925 18.9774 19.4925 17.882V6.86388C19.4925 5.76852 18.6046 4.88062 17.5092 4.88062ZM17.8397 16.7802C17.8397 17.5713 17.1984 18.2125 16.4074 18.2125H7.59289C6.80182 18.2125 6.16053 17.5713 6.16053 16.7802V7.96569C6.16053 7.17462 6.80182 6.53333 7.59289 6.53333H16.4074C17.1984 6.53333 17.8397 7.17462 17.8397 7.96569V16.7802Z"
            fill="black"
            fill-opacity="0.54"
          />
          <path
            d="M10.6729 12.7585H11.8848L11.2788 10.6799L10.6729 12.7585Z"
            fill="black"
            fill-opacity="0.54"
          />
          <path
            d="M16.4075 7.19434H7.59305C7.16695 7.19434 6.82178 7.53951 6.82178 7.9656V16.7801C6.82178 17.206 7.16695 17.5514 7.59305 17.5514H16.4075C16.8334 17.5514 17.1788 17.206 17.1788 16.7801V7.9656C17.1788 7.53951 16.8334 7.19434 16.4075 7.19434ZM12.4972 14.2771C12.3941 14.2771 12.3093 14.2539 12.279 14.1568L12.0306 13.3094H10.5337L10.2854 14.1568C10.255 14.2539 10.1703 14.2836 10.0611 14.2836C9.88533 14.2836 9.6611 14.1713 9.6611 14.0135C9.66023 13.9946 9.66217 13.9756 9.66712 13.9574L10.8731 10.0298C10.9215 9.88431 11.0973 9.81114 11.2792 9.81114C11.4608 9.81114 11.6426 9.88366 11.6913 10.0291L12.891 13.9558C12.8981 13.9733 12.9022 13.9918 12.9033 14.0105C12.9033 14.162 12.679 14.2771 12.4972 14.2771ZM14.0386 14.065C14.0386 14.2044 13.8717 14.2771 13.7081 14.2771C13.5506 14.2771 13.3776 14.2044 13.3776 14.065V10.0535C13.3776 9.90819 13.5506 9.84751 13.7081 9.84751C13.8717 9.84751 14.0386 9.90819 14.0386 10.0535V14.065Z"
            fill="black"
            fill-opacity="0.54"
          />
          <path
            d="M13.2119 20.957C13.0292 20.957 12.8813 21.1051 12.8813 21.2876V24.0421C12.8813 24.2248 13.0292 24.3726 13.2119 24.3726C13.3944 24.3726 13.5424 24.2248 13.5424 24.0421V21.2876C13.5424 21.1051 13.3944 20.957 13.2119 20.957Z"
            fill="black"
            fill-opacity="0.54"
          />
          <path
            d="M10.7881 20.957C10.6054 20.957 10.4575 21.1051 10.4575 21.2876V24.0421C10.4575 24.2248 10.6054 24.3726 10.7881 24.3726C10.9706 24.3726 11.1186 24.2248 11.1186 24.0421V21.2876C11.1186 21.1051 10.9706 20.957 10.7881 20.957Z"
            fill="black"
            fill-opacity="0.54"
          />
          <path
            d="M8.41941 20.957C8.23671 20.957 8.08887 21.1051 8.08887 21.2876V24.0421C8.08887 24.2248 8.23671 24.3726 8.41941 24.3726C8.6019 24.3726 8.74995 24.2248 8.74995 24.0421V21.2876C8.74995 21.1051 8.6019 20.957 8.41941 20.957Z"
            fill="black"
            fill-opacity="0.54"
          />
          <path
            d="M15.581 20.957C15.3983 20.957 15.2505 21.1051 15.2505 21.2876V24.0421C15.2505 24.2248 15.3983 24.3726 15.581 24.3726C15.7635 24.3726 15.9116 24.2248 15.9116 24.0421V21.2876C15.9116 21.1051 15.7635 20.957 15.581 20.957Z"
            fill="black"
            fill-opacity="0.54"
          />
          <path
            d="M10.4575 0.703346V3.45788C10.4575 3.64036 10.6054 3.78842 10.7881 3.78842C10.9706 3.78842 11.1186 3.64036 11.1186 3.45788V0.703346C11.1186 0.520859 10.9706 0.372803 10.7881 0.372803C10.6054 0.372803 10.4575 0.520859 10.4575 0.703346Z"
            fill="black"
            fill-opacity="0.54"
          />
          <path
            d="M12.8813 0.703346V3.45788C12.8813 3.64036 13.0292 3.78842 13.2119 3.78842C13.3944 3.78842 13.5424 3.64036 13.5424 3.45788V0.703346C13.5424 0.520859 13.3944 0.372803 13.2119 0.372803C13.0292 0.372803 12.8813 0.520859 12.8813 0.703346Z"
            fill="black"
            fill-opacity="0.54"
          />
          <path
            d="M15.581 3.78842C15.7635 3.78842 15.9116 3.64036 15.9116 3.45788V0.703346C15.9116 0.520859 15.7635 0.372803 15.581 0.372803C15.3983 0.372803 15.2505 0.520859 15.2505 0.703346V3.45788C15.2505 3.64036 15.3983 3.78842 15.581 3.78842Z"
            fill="black"
            fill-opacity="0.54"
          />
          <path
            d="M8.08887 0.703346V3.45788C8.08887 3.64036 8.23671 3.78842 8.41941 3.78842C8.6019 3.78842 8.74995 3.64036 8.74995 3.45788V0.703346C8.74995 0.520859 8.6019 0.372803 8.41941 0.372803C8.23671 0.372803 8.08887 0.520859 8.08887 0.703346Z"
            fill="black"
            fill-opacity="0.54"
          />
          <path
            d="M23.6695 10.8303H20.915C20.7325 10.8303 20.5845 10.9782 20.5845 11.1609C20.5845 11.3434 20.7325 11.4914 20.915 11.4914H23.6695C23.8522 11.4914 24.0001 11.3434 24.0001 11.1609C24.0001 10.9782 23.8522 10.8303 23.6695 10.8303Z"
            fill="black"
            fill-opacity="0.54"
          />
          <path
            d="M23.6695 13.2544H20.915C20.7325 13.2544 20.5845 13.4022 20.5845 13.5849C20.5845 13.7674 20.7325 13.9155 20.915 13.9155H23.6695C23.8522 13.9155 24.0001 13.7674 24.0001 13.5849C24.0001 13.4022 23.8522 13.2544 23.6695 13.2544Z"
            fill="black"
            fill-opacity="0.54"
          />
          <path
            d="M23.6695 15.6233H20.915C20.7325 15.6233 20.5845 15.7711 20.5845 15.9538C20.5845 16.1363 20.7325 16.2844 20.915 16.2844H23.6695C23.8522 16.2844 24.0001 16.1363 24.0001 15.9538C24.0001 15.7711 23.8522 15.6233 23.6695 15.6233Z"
            fill="black"
            fill-opacity="0.54"
          />
          <path
            d="M23.6695 8.46143H20.915C20.7325 8.46143 20.5845 8.60927 20.5845 8.79197C20.5845 8.97446 20.7325 9.12251 20.915 9.12251H23.6695C23.8522 9.12251 24.0001 8.97446 24.0001 8.79197C24.0001 8.60927 23.8522 8.46143 23.6695 8.46143Z"
            fill="black"
            fill-opacity="0.54"
          />
          <path
            d="M3.08507 13.2544H0.330544C0.148056 13.2544 0 13.4022 0 13.5849C0 13.7674 0.148056 13.9155 0.330544 13.9155H3.08507C3.26756 13.9155 3.41562 13.7674 3.41562 13.5849C3.41562 13.4022 3.26756 13.2544 3.08507 13.2544Z"
            fill="black"
            fill-opacity="0.54"
          />
          <path
            d="M3.08507 10.8303H0.330544C0.148056 10.8303 0 10.9782 0 11.1609C0 11.3434 0.148056 11.4914 0.330544 11.4914H3.08507C3.26756 11.4914 3.41562 11.3434 3.41562 11.1609C3.41562 10.9782 3.26756 10.8303 3.08507 10.8303Z"
            fill="black"
            fill-opacity="0.54"
          />
          <path
            d="M3.08507 8.46143H0.330544C0.148056 8.46143 0 8.60927 0 8.79197C0 8.97446 0.148056 9.12251 0.330544 9.12251H3.08507C3.26756 9.12251 3.41562 8.97446 3.41562 8.79197C3.41562 8.60927 3.26756 8.46143 3.08507 8.46143Z"
            fill="black"
            fill-opacity="0.54"
          />
          <path
            d="M3.08507 15.6233H0.330544C0.148056 15.6233 0 15.7711 0 15.9538C0 16.1363 0.148056 16.2844 0.330544 16.2844H3.08507C3.26756 16.2844 3.41562 16.1363 3.41562 15.9538C3.41562 15.7711 3.26756 15.6233 3.08507 15.6233Z"
            fill="black"
            fill-opacity="0.54"
          />
        </g>
        <defs>
          <clipPath id="clip0_6443_187">
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(0 0.372803)"
            />
          </clipPath>
        </defs>
      </svg>
      <span>AI</span>
    </div>
    <div
      title="Render"
      [class.button-disabled]="!selectedTableItemsCount"
      (click)="onRenderButtonClicked()"
      class="render-button"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="19"
        viewBox="0 0 18 19"
        fill="none"
      >
        <g clip-path="url(#clip0_6443_703)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.7582 8.44196V9.14456C16.7576 9.30595 16.8807 9.44084 17.0415 9.4549L17.6622 9.50922C17.7488 9.51678 17.8346 9.48767 17.8987 9.42896C17.9628 9.37025 17.9994 9.28736 17.9995 9.20042C17.9995 8.87798 17.9995 8.44196 17.9995 8.44196C17.9985 8.09958 17.7212 7.82232 17.3789 7.8213C17.2142 7.82042 17.0562 7.88651 16.9413 8.00438C16.8234 8.11934 16.7573 8.27729 16.7582 8.44196Z"
            fill="black"
            fill-opacity="0.54"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.5255 12.197L17.091 12.4602C17.1698 12.497 17.2605 12.4991 17.3409 12.4659C17.4214 12.4327 17.4841 12.3672 17.5139 12.2855C17.6473 11.9003 17.7536 11.5062 17.832 11.1062C17.8475 11.0203 17.8259 10.9318 17.7728 10.8625C17.7196 10.7932 17.6398 10.7496 17.5527 10.7422L16.9271 10.6875C16.7685 10.6747 16.6258 10.784 16.5969 10.9404C16.5377 11.2361 16.4602 11.5277 16.3648 11.8137C16.3123 11.9638 16.3817 12.1293 16.5255 12.197Z"
            fill="black"
            fill-opacity="0.54"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.1038 14.5986L15.5441 15.039C15.6054 15.1009 15.6899 15.1343 15.777 15.1308C15.8641 15.1274 15.9456 15.0875 16.0019 15.021C16.2573 14.7055 16.4905 14.3727 16.7001 14.0251C16.7439 13.9497 16.7541 13.8594 16.7279 13.7762C16.7019 13.6931 16.642 13.6247 16.563 13.5878L15.9979 13.3231C15.8533 13.2566 15.6818 13.3102 15.601 13.4473C15.443 13.7027 15.2698 13.9484 15.0824 14.1831C14.9818 14.3066 14.9911 14.4861 15.1038 14.5986Z"
            fill="black"
            fill-opacity="0.54"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.9485 16.3708L13.2133 16.9359C13.2501 17.015 13.3185 17.0748 13.4016 17.1009C13.4848 17.127 13.5751 17.1169 13.6505 17.0731C13.9981 16.8635 14.3309 16.6302 14.6464 16.3749C14.7132 16.3189 14.7533 16.2374 14.757 16.1503C14.7608 16.0632 14.7277 15.9786 14.6659 15.9171L14.2256 15.4768C14.1128 15.3651 13.9339 15.3565 13.811 15.4569C13.5751 15.6439 13.3283 15.8166 13.0718 15.9739C12.9351 16.0551 12.8819 16.2265 12.9485 16.3708Z"
            fill="black"
            fill-opacity="0.54"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.3153 17.3002L10.37 17.9258C10.3773 18.0128 10.421 18.0927 10.4903 18.1458C10.5596 18.199 10.6481 18.2205 10.734 18.2051C11.134 18.1266 11.5281 18.0204 11.9133 17.887C11.995 17.8572 12.0605 17.7944 12.0937 17.714C12.1269 17.6335 12.1248 17.5429 12.088 17.464L11.8239 16.8986C11.7562 16.7549 11.5909 16.6855 11.4409 16.7378C11.1549 16.8333 10.8633 16.9108 10.5677 16.97C10.4114 16.9992 10.3025 17.1417 10.3153 17.3002Z"
            fill="black"
            fill-opacity="0.54"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.36417 17.8781C7.34139 17.9619 7.35482 18.0515 7.40119 18.125C7.44756 18.1985 7.52261 18.2492 7.60811 18.2647C7.875 18.3082 8.14548 18.3385 8.41962 18.3557C8.55616 18.3643 8.69168 18.3699 8.82615 18.3724C8.91333 18.3723 8.99644 18.3356 9.05518 18.2712C9.11393 18.2068 9.14286 18.1207 9.13495 18.0338L9.08032 17.4113C9.06548 17.2531 8.93418 17.1312 8.77524 17.1283C8.55802 17.1218 8.33613 17.1053 8.11237 17.0814C8.02887 17.0724 7.94573 17.0622 7.8641 17.0504C7.70985 17.0296 7.56437 17.1274 7.52553 17.2782L7.36417 17.8781Z"
            fill="black"
            fill-opacity="0.54"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.65686 17.2426C5.01185 17.4421 5.38063 17.6161 5.7604 17.763C5.84238 17.7931 5.93319 17.7872 6.01063 17.7469C6.08804 17.7066 6.14492 17.6355 6.16725 17.5511L6.32674 16.9546C6.36689 16.8012 6.28502 16.6423 6.13684 16.586C5.8563 16.4753 5.58308 16.347 5.31879 16.2017C5.18003 16.1228 5.00408 16.162 4.91194 16.2924L4.55941 16.796C4.50942 16.8671 4.49153 16.9559 4.51005 17.0407C4.52858 17.1256 4.5818 17.1988 4.65686 17.2426Z"
            fill="black"
            fill-opacity="0.54"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.23329 15.2807C2.50005 15.586 2.78705 15.873 3.0923 16.1397C3.15895 16.1961 3.24628 16.2219 3.33286 16.2106C3.41945 16.1993 3.49728 16.1521 3.54724 16.0805L3.89822 15.5796C3.98881 15.4491 3.96617 15.2711 3.84577 15.1675C3.61944 14.9672 3.40553 14.7533 3.20525 14.5269C3.10151 14.4068 2.92384 14.3843 2.79345 14.4748L2.29288 14.8258C2.22123 14.8757 2.17395 14.9535 2.16259 15.0401C2.15128 15.1267 2.17694 15.214 2.23329 15.2807Z"
            fill="black"
            fill-opacity="0.54"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0.609967 12.6122C0.756949 12.9919 0.930859 13.3607 1.1304 13.7157C1.17416 13.7907 1.24739 13.844 1.33229 13.8625C1.41715 13.881 1.50592 13.8632 1.57697 13.8132L2.07972 13.4606C2.21003 13.3685 2.24923 13.1925 2.17034 13.0538C2.02512 12.7895 1.89677 12.5163 1.78614 12.2357C1.72979 12.0876 1.57082 12.0056 1.41747 12.0458L0.821 12.2053C0.73677 12.2279 0.665932 12.2848 0.625786 12.3622C0.585639 12.4396 0.579909 12.5303 0.609967 12.6122Z"
            fill="black"
            fill-opacity="0.54"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0.0188026 9.95325C0.0361691 10.2272 0.0665073 10.4977 0.109749 10.7648C0.125322 10.8501 0.175909 10.9251 0.249277 10.9714C0.322609 11.0177 0.412043 11.0313 0.495817 11.0087L1.09506 10.8486C1.24567 10.8096 1.34336 10.6642 1.32255 10.51C1.31046 10.4271 1.30019 10.344 1.29151 10.2617C0.917147 7.00936 2.62465 3.87201 5.55912 2.42047C8.49359 0.968928 12.0234 1.51569 14.3812 3.78697H12.4522C12.1396 3.77959 11.8662 3.99635 11.8021 4.30244C11.7711 4.48279 11.8212 4.66767 11.9391 4.80758C12.0571 4.94753 12.2308 5.02828 12.4137 5.02828H15.8274C16.1698 5.02726 16.447 4.74996 16.4481 4.40762V1.03249C16.4555 0.719857 16.2387 0.446494 15.9326 0.382653C15.7523 0.351646 15.5675 0.401742 15.4275 0.519616C15.2876 0.637454 15.2068 0.811049 15.2067 0.993994V2.86219C12.5254 0.302641 8.54857 -0.350042 5.18978 1.21814C1.83099 2.78632 -0.221937 6.25423 0.0188026 9.95325Z"
            fill="black"
            fill-opacity="0.54"
          />
          <path
            d="M11.9126 8.64426C12.5793 9.02916 12.5793 9.99142 11.9126 10.3763L8.29328 12.4659C7.62661 12.8508 6.79328 12.3697 6.79328 11.5999L6.79328 7.42068C6.79328 6.65088 7.62661 6.16975 8.29328 6.55465L11.9126 8.64426Z"
            fill="black"
            fill-opacity="0.54"
          />
        </g>
        <defs>
          <clipPath id="clip0_6443_703">
            <rect
              width="18"
              height="18"
              fill="white"
              transform="translate(0 0.372803)"
            />
          </clipPath>
        </defs>
      </svg>
      <span>render</span>
    </div>
    <div
      title="Download"
      [class.button-disabled]="!selectedTableItemsCount"
      class="download-button"
      (click)="selectedTableItemsCount && onDownloadButtonClicked()"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.7998 20.7727C5.24752 20.7727 4.7998 20.325 4.7998 19.7727C4.7998 19.2204 5.24752 18.7727 5.79981 18.7727H17.7998C18.3521 18.7727 18.7998 19.2204 18.7998 19.7727C18.7998 20.325 18.3521 20.7727 17.7998 20.7727H5.7998ZM8.99921 4.1729C8.99921 4.06244 9.08876 3.9729 9.19921 3.9729H14.7992C14.9097 3.9729 14.9992 4.06244 14.9992 4.1729V9.9729H18.5164C18.6946 9.9729 18.7838 10.1883 18.6578 10.3143L12.1406 16.8315C12.0625 16.9096 11.9359 16.9096 11.8578 16.8315L5.34064 10.3143C5.21464 10.1883 5.30388 9.9729 5.48206 9.9729H8.99921V4.1729ZM11.9997 14.1428L14.1697 11.9728H12.9997V5.97282H10.9997V11.9728H9.82968L11.9997 14.1428Z"
          fill="black"
          fill-opacity="0.54"
        />
      </svg>
      <span>download</span>
    </div>
  </evrideo-ag-grid-evrideo-header>
  <ag-grid-angular
    #searchGrid
    class="ag-theme-balham ag-theme-evrideo"
    (gridReady)="onGridReady($event)"
    (selectionChanged)="onSelectionChanged($event)"
    [gridOptions]="gridOptions"
  ></ag-grid-angular>
  <ag-grid-evrideo-footer
    [selectedPageSize]="pageSize"
    [gridApi]="gridApi"
    (pageSizeChanged)="setPageSize($event)"
  >
  </ag-grid-evrideo-footer>
</div>
